import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, Resolve } from '@angular/router'

import { from, Observable, of as observableOf } from 'rxjs'
import { map } from 'rxjs/operators'

import { FirebaseLemonator } from 'app/_angular/service/firebase-lemonator.service'
import { Tilintarkastaja } from 'app/_jaettu-lemonator/model/tilintarkastaja'
import { TilintarkastajaUriService } from 'app/_jaettu-lemonator/service/tilintarkastaja-uri.service'
import { TilintarkastajaService } from 'app/_jaettu-lemonator/service/tilintarkastaja.service'

export interface TilintarkastajaComponentData {
  tilintarkastaja: Tilintarkastaja
}

@Injectable()
export class TilintarkastajaComponentDataResolve implements Resolve<TilintarkastajaComponentData> {
  private existingData: TilintarkastajaComponentData = null

  constructor(
    private tilintarkastajaService: TilintarkastajaService,
    private tilintarkastajaUriService: TilintarkastajaUriService,
    private firebase: FirebaseLemonator,
  ) {}

  asetaOlemassaolevaData(data: TilintarkastajaComponentData) {
    this.existingData = data
  }

  resolve(route: ActivatedRouteSnapshot): Observable<TilintarkastajaComponentData> {
    const avain = route.params['avain']
    return this.annaTilintarkastajaObservable(avain).pipe(
      map(tilintarkastaja => {
        const returnValue: TilintarkastajaComponentData = {
          tilintarkastaja: tilintarkastaja,
        }
        return returnValue
      }),
    )
  }

  private annaTilintarkastajaObservable(avain: string): Observable<Tilintarkastaja> {
    if (avain === 'uusi') {
      return observableOf(this.tilintarkastajaService.annaUusiTilintarkastaja(this.firebase.firestoreCreateId()))
    }
    if (this.existingData && this.existingData.tilintarkastaja && this.existingData.tilintarkastaja.avain === avain) {
      return observableOf(this.existingData.tilintarkastaja)
    }
    return from(this.firebase.firestoreDoc<Tilintarkastaja>(this.tilintarkastajaUriService.annaTilintarkastajaUri(avain)).get())
  }
}
